// src/api/api.js
//const API_BASE_URL = "http://localhost:63994"; // 🔹 Update if needed
//const API_BASE_URL = "http://192.168.1.51:2002"; // 🔹 Update if needed
const API_BASE_URL ="https://rmpapi.iworkx.in"


const api = {

  /* -------------------- Database Key Helpers -------------------- */
  // 🔹 Always fetch the latest key from sessionStorage

  getDatabaseKey: () => sessionStorage.getItem("databaseKey"),


  // 🔹 Set or update database key manually (optional)
  setDatabaseKey: (key) => {
    sessionStorage.setItem("databaseKey", key);
    console.log("✅ Database key set:", key);
  },

  /* -------------------- Common GET Request -------------------- */
  get: async (endpoint, params = {}) => {
    try {
      const DATABASE_KEY = api.getDatabaseKey(); // Always fresh
      if (!DATABASE_KEY) throw new Error("Database key not set!");

      const url = new URL(`${API_BASE_URL}/${endpoint}`);
      const fullParams = { ...params, databaseKey: DATABASE_KEY };

      Object.keys(fullParams).forEach((key) =>
        url.searchParams.append(key, fullParams[key])
      );

      console.log("🌐 GET:", url.toString());

      const response = await fetch(url);
      if (!response.ok)
        throw new Error(`HTTP error! status: ${response.status}`);

      const json = await response.json();
      return json[Object.keys(json)[0]]; // Return first root object
    } catch (error) {
      console.error("❌ GET API error:", error);
      throw error;
    }
  },

  /* -------------------- Common POST Request -------------------- */
  post: async (endpoint, body = {}, queryParams = {}) => {
    try {
      const DATABASE_KEY = api.getDatabaseKey(); // Always fresh
      if (!DATABASE_KEY) throw new Error("Database key not set!");

      const url = new URL(`${API_BASE_URL}/${endpoint}`);
      const fullQueryParams = { ...queryParams, databaseKey: DATABASE_KEY };
      Object.keys(fullQueryParams).forEach((key) =>
        url.searchParams.append(key, fullQueryParams[key])
      );

      console.log("🌐 POST:", url.toString(), "Body:", body);

      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      if (!response.ok)
        throw new Error(`HTTP error! status: ${response.status}`);

      return response.json();
    } catch (error) {
      console.error("❌ POST API error:", error);
      throw error;
    }
  },

  /* -------------------- API Endpoints -------------------- */
  getAssetRegisterList: (UserName) =>  api.get("AssetRegisterListAPI", { UserName }),
  getAssetRegister: (UserName, Ownership) => api.get("GetAssetRegisterAPI", { User: UserName, Ownership }),
  SaveBasicAssetRegister: (payload) => api.post("SaveBasicAssetRegisterAPI", payload),
  EditBasicAssetRegister: (AssetId) => api.get("EditBasicAssetRegisterAPI", { AssetId }),
  checkLogin: (userName, userpwd) =>  api.post("AssetCheckLogin", { UserName: userName, Userpwd: userpwd }),
  AssetCalibrationLogListAPI: (User) => api.get("AssetCalibrationLogListAPI", { User }),
  GetCalibrationlogAPI: (User) => api.get("GetCalibrationlogAPI", { User }),
  SaveCalibrationLogAPI: (payload) => api.post("SaveCalibrationLogAPI", payload),
  GetAssetCaliblogAPI: (AssetId, User) => api.get("GetAssetCaliblogAPI", { AssetId, User }),
  EditAssetCalibrationLogAPI: (LogId) => api.get("EditAssetCalibrationLogAPI", { LogId }),
  GetServiceInvoiceAPI: (Vid) => api.get("GetServiceInvoiceAPI", { Vid }),
  CalibrationDashboardAPI: (User) => api.get("CalibrationDashboardAPI", { User }),
  SaveAssetCalibration: (payload) => api.post("SaveAssetCalibrationAPI", payload),
  GetAssetCalibration: (AssetID, User) => api.get("GetAssetCalibrationAPI", { AssetID, User }),
  EditAssetCalibration: (AssetId) => api.get("EditAssetCalibrationAPI", { AssetId }),
  CompanyDetailsAPI: (User) => api.get("CompanyDetailsAPI", { User }),
  GetAssetMovementList: (User) => api.get("GetAssetMovementListAPI", { User }),
  GetAssetMovement: (User) => api.get("GetAssetMovementAPI", { User }),
  SaveAssetMovement: (payload) => api.post("SaveAssetMovementAPI", payload),
  EditAssetMovement: (MovementID) => api.get("EditAssetMovementAPI", { MovementID }),
  GetDCNonRetHTMLPrint: (GipId) => api.get("GetDCNonRetHTMLPrint", { GipId }),
  GetTicketList: (User) => api.get("GetTicketListAPI", { User }),
  GetTicketValues: (User) => api.get("GetTicketValuesAPI", { User }),
  SaveTicket: (payload) => api.post("SaveTicketAPI", payload),
  EditTicket: (TicketId) => api.get("EditTicketAPI", { TicketId }),
  GetAssetPrdItemAPI: (UserName) =>api.get("GetAssetPrdItemAPI", { UserName }),
  SaveAssetprdItemAPI: (payload) => api.post("SaveAssetprdItemAPI", payload),
  DeleteAssetPrdItemAPI: (AssetId,Seqid) => api.get("DeleteAssetPrdItemAPI", {AssetId,Seqid }),
  EditAssetPrdItem_API: (AssetId) =>api.get("EditAssetPrdItem_API", { AssetId }),
  DeleteAssetspares: (SpareId) => api.get("DeleteAssetsparesAPI", { SpareId }),
  EditAssetspares_API: (PrimeIdStr) => api.get("EditAssetspares_API", { PrimeIdStr }),
  SaveAssetspares: (payload) => api.post("SaveAssetsparesAPI", payload),
  GETItemMaster: (UserName, Materialtype) => api.get("GETItemMaster", { UserName, Materialtype }),
  GetBoEDatas: (username, Type) => api.get("GetBoEDatas", { username, Type }),
  GetImpQtyKgsByBOENo: (username, BoeNo) => api.get("GetImpQtyKgsByBOENo", { username, BoeNo }),
  GetSalesShippedunderMOOWR: (username, BoeNo) => api.get("GetSalesShippedunderMOOWR", { username, BoeNo }),
  GetBoEDatasWithBoeNo: (username, Type,BoeNo) => api.get("GetBoEDatasWithBoeNo", { username, Type ,BoeNo}),
  GetScrapDetailsBoE: (username) => api.get("GetScrapDetailsBoE", { username}),
  GetAllScrapDetailsBoE: (username) => api.get("GetAllScrapDetailsBoE", { username }),
  EditScrapBoE: (PrimeId) => api.get("EditScrapBoE", { PrimeId }),
  SaveScrapBoE: (payload) => api.post("SaveScrapBoE", payload),
};



// ✅ Upload file(s)
api.UploadAttachment = async (formData) => {
  const DATABASE_KEY = api.getDatabaseKey();
  if (!DATABASE_KEY) throw new Error("Database key not set!");

  const url = new URL(`${API_BASE_URL}/api/UploadAttachment`);
  url.searchParams.append("databaseKey", DATABASE_KEY); // 🔹 Add it here

  console.log("🌐 UploadAttachment:", url.toString());

  const response = await fetch(url, {
    method: "POST",
    body: formData, // Don't add headers — fetch will set boundary automatically
  });

  if (!response.ok) throw new Error(`Upload failed! ${response.status}`);
  return response.json();
};


// ✅ Get attachments for a record
api.GetAttachments = async (MdlId, PrimeId) => {
  const DATABASE_KEY = api.getDatabaseKey();
  if (!DATABASE_KEY) throw new Error("Database key not set!");

  const url = new URL(`${API_BASE_URL}/api/GetAttachments`);
  url.searchParams.append("mdlId", MdlId);
  url.searchParams.append("primeId", PrimeId);
  url.searchParams.append("databaseKey", DATABASE_KEY); // 🔹 Include key

  console.log("🌐 GetAttachments:", url.toString());

  const response = await fetch(url);
  if (!response.ok) throw new Error(`Failed to fetch attachments`);
  return response.json();
};


// ✅ Delete attachment by ID
api.DeleteAttachment = async (id) => {
  const DATABASE_KEY = api.getDatabaseKey();
  if (!DATABASE_KEY) throw new Error("Database key not set!");

  const url = new URL(`${API_BASE_URL}/api/DeleteAttachment`);
  url.searchParams.append("id", id);
  url.searchParams.append("databaseKey", DATABASE_KEY); // 🔹 Include key

  console.log("🌐 DeleteAttachment:", url.toString());

  const response = await fetch(url, { method: "DELETE" });
  if (!response.ok) throw new Error("Failed to delete attachment");
  return response.json();
};


export default api;


